import request from "@/utils/request";
import qs from "qs";

export function getGroupBuyActivities(params) {
  return request({ url: "/groupBuy/activity/list", method: "get", params });
}
export function getGroupBuyActivityDetail(params) {
  return request({ url: "/groupBuy/activity/detail", method: "get", params });
}
export function getGroupBuyActivityGoods(params) {
  return request({ url: "/groupBuy/activity/goods", method: "get", params });
}
export function saveGroupBuyActivity(params) {
  return request.post("/groupBuy/activity/save", qs.stringify(params));
}
export function endGroupBuyActivity(params) {
  return request.post("/groupBuy/activity/end", qs.stringify(params));
}
export function createGroupBuyVirtualTeam(params) {
  return request.post("/groupBuy/activity/virtual-team", qs.stringify(params));
}
export function getGroupBuyStatistics(params) {
  return request({ url: "/groupBuy/activity/statistics", method: "get", params });
}
export function getGroupBuyTeams(params) {
  return request({ url: "/groupBuy/team/list", method: "get", params });
}
export function getGroupBuyTeamDetail(params) {
  return request({ url: "/groupBuy/team/detail", method: "get", params });
}
export function manualSuccessGroupBuyTeam(params) {
  return request.post("/groupBuy/team/manual-success", qs.stringify(params));
}
export function getGroupBuyOrders(params) {
  return request({ url: "/groupBuy/order/list", method: "get", params });
}
